import { useMemo } from "react";

export function useDecimalOperator() {
    const decimalSeparator = useMemo(() => {
        const n = 1.1;
        return n.toLocaleString("en-US").substring(1, 2);
    }, []);

    return decimalSeparator;
}
